import { render, staticRenderFns } from "./MyAnswers.vue?vue&type=template&id=a374a6a2&"
import script from "./MyAnswers.vue?vue&type=script&lang=js&"
export * from "./MyAnswers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports